var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.5 13.5"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M1.17 13.07a1.464 1.464 0 001.07.44h6.02A1.5 1.5 0 009.73 12V3h-9v9a1.464 1.464 0 00.44 1.07zM7.87.75L7.13.01H3.37l-.74.74H-.01v1.51h10.52V.75H7.87z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }